import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { FreeAuditPage } from "@/components/audit/FreeAuditPage";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/es/auditoria/")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: "Auditoría Shopify Gratis: Performance, SEO Técnico, CRO y Legibilidad por IA · Shugert",
    description: "Ejecuta un scan gratuito de 30–60 segundos sobre señales públicas de performance, SEO técnico, experiencia de compra y legibilidad por IA. Consulta el score y un hallazgo antes de desbloquear los checks detallados.",
    path: "/es/auditoria",
    altPath: alternatePath("/es/auditoria", "en"),
    jsonLd: breadcrumbJsonLd([
      { name: "Inicio", path: "/es" },
      { name: "Auditoría Shopify gratis", path: "/es/auditoria" },
    ]),
  }),
  component: () => (
    <SiteShell>
      <FreeAuditPage locale="es" />
    </SiteShell>
  ),
});
